import { render, staticRenderFns } from "./data-diet-menu.vue?vue&type=template&id=fb840310&scoped=true&"
import script from "./data-diet-menu.vue?vue&type=script&lang=js&"
export * from "./data-diet-menu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb840310",
  null
  
)

export default component.exports

/* chakra-loader */
const installChakraComponents = require("!../../../node_modules/chakra-loader/lib/install-components.js")
installChakraComponents(component, {CText: require('@chakra-ui/vue').CText, CFlex: require('@chakra-ui/vue').CFlex, CImage: require('@chakra-ui/vue').CImage, CListItem: require('@chakra-ui/vue').CListItem, CList: require('@chakra-ui/vue').CList})
